import { Colors, Text } from "@zapier/design-system";
import { styled } from "lib/theme";
import { Account } from "server/schemas/user";
import { trpc } from "utils/trpc";
import LoadingButton from "components/LoadingButton";

interface Props {
  account: Account;
  onSelect: () => void;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid ${Colors.neutral700};
  border-radius: 8px;
`;

export default function AccountItem({ account, onSelect }: Props) {
  const selectAccountForUpgrade =
    trpc.users.selectAccountForUpgrade.useMutation({
      onSuccess: onSelect,
    });

  const handleAccountSelection = () => {
    selectAccountForUpgrade.mutate({
      accountId: account.id,
    });
  };

  return (
    <Wrapper>
      <div>
        <Text tag="div" type="paragraph1Semibold">
          {account.name}
        </Text>
        <Text tag="div" type="paragraph3">
          {account.id}
        </Text>
      </div>
      <LoadingButton
        loading={selectAccountForUpgrade.isLoading}
        size="small"
        onClick={handleAccountSelection}
      >
        Select
      </LoadingButton>
    </Wrapper>
  );
}
